// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* API Inspector Styles */

.api-inspector {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.api-inspector h2 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 20px;
  color: #1f2937;
}

/* Filters */
.inspector-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 6px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-group label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}

.filter-group select {
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

/* Content Layout */
.inspector-content {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 24px;
  min-height: 400px;
}

/* Call List */
.call-list {
  border-right: 1px solid #e5e7eb;
  padding-right: 20px;
}

.call-list h3 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.calls {
  display: grid;
  gap: 8px;
  max-height: 600px;
  overflow-y: auto;
}

.call-item {
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.call-item:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.call-item.selected {
  background: #f0f4ff;
  border-color: #667eea;
  box-shadow: 0 0 0 1px #667eea;
}

.call-item-header {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.method {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  min-width: 40px;
  text-align: center;
}

.api-inspector .status {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  background: #3b82f6;
}

.api-inspector .status.error {
  background: #ef4444;
}

.duration {
  font-size: 11px;
  color: #6b7280;
  padding: 2px 6px;
  background: #f3f4f6;
  border-radius: 3px;
  margin-left: auto;
}

.call-item-path {
  font-family: "Courier New", monospace;
  font-size: 11px;
  color: #374151;
  word-break: break-all;
  margin-bottom: 4px;
}

.call-item-time {
  font-size: 10px;
  color: #9ca3af;
}

/* Call Details */
.call-details {
  padding-left: 20px;
}

.call-details h3 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.details-section {
  display: grid;
  gap: 12px;
  margin-bottom: 20px;
}

.details-item {
  display: grid;
  gap: 6px;
}

.details-item label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.details-item code {
  display: block;
  padding: 8px;
  background: #1f2937;
  color: #e5e7eb;
  border-radius: 4px;
  font-family: "Courier New", monospace;
  font-size: 12px;
  word-break: break-all;
  overflow-x: auto;
}

.url-code {
  word-break: break-all;
}

.details-item pre {
  margin: 0;
  padding: 12px;
  background: #1f2937;
  color: #e5e7eb;
  border-radius: 4px;
  font-family: "Courier New", monospace;
  font-size: 12px;
  line-height: 1.4;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

/* Alerts */
.api-inspector .alert {
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  margin: 0;
}

.api-inspector .alert-error {
  background: #fee2e2;
  color: #991b1b;
  border-left: 4px solid #dc2626;
  word-break: break-word;
}

/* Empty State */
.api-inspector .empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

/* Scrollbars */
.calls::-webkit-scrollbar {
  width: 6px;
}

.calls::-webkit-scrollbar-track {
  background: transparent;
}

.calls::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.calls::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

pre::-webkit-scrollbar {
  height: 6px;
}

pre::-webkit-scrollbar-track {
  background: transparent;
}

pre::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 3px;
}

pre::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

/* Responsive */
@media (max-width: 1024px) {
  .inspector-content {
    grid-template-columns: 250px 1fr;
    gap: 16px;
  }

  .call-list {
    padding-right: 16px;
  }

  .call-details {
    padding-left: 16px;
  }
}

@media (max-width: 768px) {
  .api-inspector {
    padding: 16px;
  }

  .inspector-filters {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .inspector-content {
    grid-template-columns: 1fr;
    gap: 16px;
    min-height: auto;
  }

  .call-list {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    padding-right: 0;
    padding-bottom: 16px;
  }

  .call-details {
    padding-left: 0;
  }

  .calls {
    max-height: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/QC/ApiInspector.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* API Inspector Styles */\n\n.api-inspector {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.api-inspector h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 20px;\n  color: #1f2937;\n}\n\n/* Filters */\n.inspector-filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 6px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.filter-group select {\n  padding: 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 13px;\n  background: white;\n}\n\n/* Content Layout */\n.inspector-content {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 24px;\n  min-height: 400px;\n}\n\n/* Call List */\n.call-list {\n  border-right: 1px solid #e5e7eb;\n  padding-right: 20px;\n}\n\n.call-list h3 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.calls {\n  display: grid;\n  gap: 8px;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.call-item {\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.call-item:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.call-item.selected {\n  background: #f0f4ff;\n  border-color: #667eea;\n  box-shadow: 0 0 0 1px #667eea;\n}\n\n.call-item-header {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.method {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  min-width: 40px;\n  text-align: center;\n}\n\n.api-inspector .status {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  background: #3b82f6;\n}\n\n.api-inspector .status.error {\n  background: #ef4444;\n}\n\n.duration {\n  font-size: 11px;\n  color: #6b7280;\n  padding: 2px 6px;\n  background: #f3f4f6;\n  border-radius: 3px;\n  margin-left: auto;\n}\n\n.call-item-path {\n  font-family: \"Courier New\", monospace;\n  font-size: 11px;\n  color: #374151;\n  word-break: break-all;\n  margin-bottom: 4px;\n}\n\n.call-item-time {\n  font-size: 10px;\n  color: #9ca3af;\n}\n\n/* Call Details */\n.call-details {\n  padding-left: 20px;\n}\n\n.call-details h3 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.details-section {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.details-item {\n  display: grid;\n  gap: 6px;\n}\n\n.details-item label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.details-item code {\n  display: block;\n  padding: 8px;\n  background: #1f2937;\n  color: #e5e7eb;\n  border-radius: 4px;\n  font-family: \"Courier New\", monospace;\n  font-size: 12px;\n  word-break: break-all;\n  overflow-x: auto;\n}\n\n.url-code {\n  word-break: break-all;\n}\n\n.details-item pre {\n  margin: 0;\n  padding: 12px;\n  background: #1f2937;\n  color: #e5e7eb;\n  border-radius: 4px;\n  font-family: \"Courier New\", monospace;\n  font-size: 12px;\n  line-height: 1.4;\n  overflow-x: auto;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n/* Alerts */\n.api-inspector .alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  margin: 0;\n}\n\n.api-inspector .alert-error {\n  background: #fee2e2;\n  color: #991b1b;\n  border-left: 4px solid #dc2626;\n  word-break: break-word;\n}\n\n/* Empty State */\n.api-inspector .empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Scrollbars */\n.calls::-webkit-scrollbar {\n  width: 6px;\n}\n\n.calls::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.calls::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n}\n\n.calls::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\npre::-webkit-scrollbar {\n  height: 6px;\n}\n\npre::-webkit-scrollbar-track {\n  background: transparent;\n}\n\npre::-webkit-scrollbar-thumb {\n  background: #4b5563;\n  border-radius: 3px;\n}\n\npre::-webkit-scrollbar-thumb:hover {\n  background: #6b7280;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .inspector-content {\n    grid-template-columns: 250px 1fr;\n    gap: 16px;\n  }\n\n  .call-list {\n    padding-right: 16px;\n  }\n\n  .call-details {\n    padding-left: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .api-inspector {\n    padding: 16px;\n  }\n\n  .inspector-filters {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .inspector-content {\n    grid-template-columns: 1fr;\n    gap: 16px;\n    min-height: auto;\n  }\n\n  .call-list {\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n    padding-right: 0;\n    padding-bottom: 16px;\n  }\n\n  .call-details {\n    padding-left: 0;\n  }\n\n  .calls {\n    max-height: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
